import React from "react";
import Select from "react-select";

function SelectOption({
  label,
  value,
  onChange,
  isClearable,
  options,
  placeholder,
  isMulti,
  ...rest
}) {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#fff",
      borderColor: "#1392ff",
      minHeight: "2px",
      "&:hover": {
        borderColor: "#1392ff", // Hover border color
      },
      fontWeight: "300",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#888",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#333",
      fontWeight: "300",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#888",
      "&:hover": {
        color: "#555",
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: "#fff",
      borderRadius: "4px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
      marginTop: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#e6e6e6" : "#fff",
      color: "#333",
      padding: 10,
      "&:active": {
        backgroundColor: "#ddd",
      },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#e0e0e0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#333",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#999",
      "&:hover": {
        backgroundColor: "#ff6b6b",
        color: "white",
      },
    }),
  };

  return (
    <div className="mb-3">
      <label className="input-label mb-2">{label}</label>
      <Select
        value={value}
        onChange={onChange}
        isClearable={isClearable}
        options={options}
        placeholder={placeholder}
        styles={customStyles}
        isMulti={isMulti}
        {...rest}
      />
    </div>
  );
}

export default SelectOption;
